import {useMemo} from 'react';
import useTimer, {getDatesDifferenceInSeconds} from '../../../hooks/useTimer';

const TotalTime = ({startedAt}) => {
  const initialDatesDiff = useMemo(() =>
    getDatesDifferenceInSeconds(startedAt),
  [startedAt]);

  const {resultTimeHHMMSS: resultTime} = useTimer({
    initialDiff: initialDatesDiff,
    initialActive: !!startedAt
  });

  return (
    <span className="value">{resultTime}</span>
  );
};

export default TotalTime;
